import { useCallback } from "react";
import { AddOnsApi, IdentityMelcoModelsBoolResponse, useAPIAction } from "melco-shared-logic";

export const useAddOnActivate = (): (() => Promise<IdentityMelcoModelsBoolResponse | undefined>) => {
  const [addOnActivate] = useAPIAction(
    AddOnsApi,
    async (api) => {
      const data = await api.addsOnActivate();

      console.log("data is , ", data)
      return {
        successMessages: [],
        data,
      };
    },
    {
      translationPrefix: "",
    }
  );

  return useCallback(
    async () => {
      try {
        let response = await addOnActivate();
        return response
      } catch (e) {
        // error handling is already done in useAPIAction
      }



    },
    [addOnActivate]
  );
};
